module.exports = "/assets/bd4478e9172897eb770b7a4efc8771ee.svg";